import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { StencilProvider, ThemeMode } from "@amzn/stencil-react-components/context";
import { QueryClientProvider } from "./providers/query-client-provider";
import { SessionProvider } from "./providers/session-provider";
import App from "./App";
import AuthLoading from "./common/components/AuthLoading/auth-loading";
import SessionExpired from "./pages/session-expired";
import { Paths } from "./common/paths/paths";
import "./styles/main.scss";
import { BASE_ROUTE } from "./common/constants";

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <StencilProvider themeMode={ThemeMode.Light} mode="dense">
      <QueryClientProvider>
        <BrowserRouter basename={BASE_ROUTE}>
          <Switch>
            <Route exact path={Paths.sessionExpired.url} component={SessionExpired} />
            <Route>
              <AuthLoading>
                <SessionProvider>
                  <App />
                </SessionProvider>
              </AuthLoading>
            </Route>
          </Switch>
        </BrowserRouter>
      </QueryClientProvider>
    </StencilProvider>
  </React.StrictMode>
);
